var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Color Copy 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.4,11.4274 L14.4,8.2 C14.4,5.3047 12.4335,2.8657 9.7695,2.1322 C9.5058,1.468 8.8614,1 8.1,1 C7.3386,1 6.6942,1.468 6.4305,2.1322 C3.7665,2.8666 1.8,5.3047 1.8,8.2 L1.8,11.4274 L0.2637,12.9637 C0.0945,13.132 0,13.3606 0,13.6 L0,15.4 C0,15.8977 0.4023,16.3 0.9,16.3 L15.3,16.3 C15.7977,16.3 16.2,15.8977 16.2,15.4 L16.2,13.6 C16.2,13.3606 16.1055,13.132 15.9363,12.9637 L14.4,11.4274 Z M14.4,14.5 L1.8,14.5 L1.8,13.9726 L3.3363,12.4363 C3.5055,12.268 3.6,12.0394 3.6,11.8 L3.6,8.2 C3.6,5.7187 5.6187,3.7 8.1,3.7 C10.5813,3.7 12.6,5.7187 12.6,8.2 L12.6,11.8 C12.6,12.0394 12.6945,12.268 12.8637,12.4363 L14.4,13.9726 L14.4,14.5 Z M8.1,19 C9.2799,19 10.2663,18.2494 10.6362,17.2 L5.5638,17.2 C5.9337,18.2494 6.9201,19 8.1,19 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-32.000000, -399.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default-Menu"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(17.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(15.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Color-Copy-9"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#435971",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.2,
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.f55edc0dc45d1fcc8f5212e3f368060d.svg";
export { ForwardRef as ReactComponent };